module.exports = __webpack_public_path__ + "img/templel.5ce8cdf4.png";